import React from 'react';
import { TrendingUp } from 'lucide-react';

export const KPICard = ({ icon, title, value, trend, trendUp = true, bgColor = 'bg-blue-50' }) => (
  <div className={`${bgColor} p-4 rounded-lg flex items-center`}>
    <div className="mr-4">
      {icon}
    </div>
    <div>
      <p className="text-sm text-gray-600">{title}</p>
      <p className="text-xl font-bold">{value}</p>
      <div className={`text-xs flex items-center ${trendUp ? 'text-green-600' : 'text-red-600'}`}>
        {/* <TrendingUp size={14} className={!trendUp ? 'rotate-180' : ''} /> */}
        <span className="ml-1">{trend}</span>
      </div>
    </div>
  </div>
);





export const KPICardBoth = ({
  icon1,
  icon2,
  title1,
  value1,
  trend1,
  trendUp1 = true,
  title2,
  value2,
  trend2,
  trendUp2 = true,
  bgColor = 'bg-blue-50',
  onClick1,
  onClick2
}) => (
  <div className={`${bgColor} p-4 rounded-lg flex justify-between`}>
    
    {/* Section 1: Left side */}
    <div
      className="flex items-center cursor-pointer hover:opacity-80 transition"
      onClick={onClick1}
    >
      <div className="mr-4">
        {icon1}
      </div>
      <div>
        <p className="text-sm text-gray-600">{title1}</p>
        <p className="text-xl font-bold">{value1}</p>
        <div className={`text-xs flex items-center ${trendUp1 ? 'text-green-600' : 'text-red-600'}`}>
          <span className="ml-1">{trend1}</span>
        </div>
      </div>
    </div>

    {/* Section 2: Right side */}
    <div
      className="flex items-center cursor-pointer hover:opacity-80 transition"
      onClick={onClick2}
    >
      <div>
        <p className="text-sm text-gray-600">{title2}</p>
        <p className="text-xl font-bold">{value2}</p>
        <div className={`text-xs flex items-center ${trendUp2 ? 'text-green-600' : 'text-red-600'}`}>
          <span className="ml-1">{trend2}</span>
        </div>
      </div>
      <div className="ml-4">
        {icon2}
      </div>
    </div>

  </div>
);

